// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"QuotePage_themeRoot__1ILYv","startDate":"QuotePage_startDate__2tuSR","quotePageHeader":"QuotePage_quotePageHeader__1oaYy","disable":"QuotePage_disable__1_cw0"};